import api from './apiClient';
import { isLanDevAutoLoginLocation } from '../utils/devLoginLocation';

export const isLanDevAutoLogin = () =>
    isLanDevAutoLoginLocation({
        nodeEnv: process.env.NODE_ENV,
        hostname: window.location.hostname,
        port: window.location.port,
    });

const apiDevLogin = async () => {
    const response = await api.post('/api/captions/dev-login');
    return response.data;
};

export default apiDevLogin;
